//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: [],
    data () {
        return {
            tableData: [],
            pgData: {},

            dialogVisible: false,
            dialogTitle: '',

            formSearch: {
                applyno: '',
                invoicecode: '',
                invoiceno: '',
                fileguid: '',
            },
            fileguid:"",

            kpstatusOption:[
                {value: '0',label: '未开票'},
                {value: '1',label: '已开票'},
            ]
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        }
    },
    methods: {
        fielUploadSuccess(fileguid){
            this.formSearch[fileguid] = this[fileguid];
        },
        afterSend(){
            this.dialogVisible = false;
        }, 
        kpHandler(row) {
            this.dialogTitle = '开票';
            this.formSearch.applyno = row.applyno;
            this.dialogVisible = true;
        },
        reloadHandler() {
            this.$refs.page.reload();
        },
        GenNonDuplicateID(){//获取随机字符串
            let idStr = Date.now().toString(36);
            idStr += Math.random().toString(36).substr(3);
            return idStr;
        },
        submit(){
            var that = this;
            this.$post(this.getStore('fy') + '/invoice/kaipiao', this.formSearch, (data, res) => {
                ShowMsg.call(this, res.msg);
                that.dialogVisible = false;
            })
        }
    },
    mounted: function() {
        this.fileguid = this.GenNonDuplicateID();
    }
}
